import { IDataForObjectIsRejected } from '../../../actions/userObject/profile/requestFetchUserProfile'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IDataForObjectIsRejected,
): IUserObjectStore {
  return {
    ...state,
    profileRequest: {
      ...state.profileRequest,
      errMessage: action.errMessage,
      isLoading: true,
    },
  }
}
